<template>
    <BaseButton
        :button-text="tokens.newDesign.confirmWithdrawal"
        :button-style="'filled-primary'"
        :disabled="disabled"
        @click.native="requestWithdrawal"
    />
</template>

<script>
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"
import {NOTIFICATION_ERROR} from "@/store/mutations.type"
import {MINIMUM_WITHDRAWAL} from "@/common/config"
import {WITHDRAWAL_REQUEST} from "@/store/actions.type"
import {mapGetters} from "vuex"

export default {
    name: "SendWithdrawal",
    components: {BaseButton},
    props: {
        disabled: {
            type: Boolean,
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        requestWithdrawal() {
            let amount = String(this.info.amount)
            amount = amount.includes(',') ? amount.replace(/,/, '.') : amount
            amount = parseFloat(amount)

            for (let n in this.withdrawals) {
                if (this.withdrawals[n].status === 0) {
                    this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_ONE_PENDING_WITHDRAWAL')
                    return
                }
            }

            if (isNaN(parseFloat(amount))) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumWithdrawal + ' $' + MINIMUM_WITHDRAWAL)
                return
            }

            if (this.info.method === 'bank' || this.info.method === 'card' || this.info.method === 'zelle') {
                if (amount < MINIMUM_WITHDRAWAL) {
                    this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumWithdrawal + ' $' + MINIMUM_WITHDRAWAL)
                    return
                }
            } else {
                let currentSymbol = this.info.method === 'USDT' ? 
                    1 : this.symbols[(this.info.method + 'USD')].quote.bid

                if (amount * currentSymbol < MINIMUM_WITHDRAWAL) {
                    this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumWithdrawal + ' $' + MINIMUM_WITHDRAWAL)
                    return
                }
            }

            let details = ''

            switch (this.info.method) {
                case 'BTC':
                    details = `BTC: ${this.info.wallet}`
                    break
                case 'bank':
                    details =
                        `Account: ${this.info.account}\nAccount holder: ${this.info.holder}${this.info.iban ? `\nIBAN: ` + this.info.iban : ''}${this.info.swift ? '\nSWIFT: ' + this.info.swift : ''}${this.info.recipientAddress ? '\nRecipient Address: ' + this.info.recipientAddress : ''}${this.info.routingNumber ? '\nRouting Number: ' + this.info.routingNumber : ''}${this.info.bankBeneficiary ? '\nBank of Beneficiary Name: ' + this.info.bankBeneficiary : ''}${this.info.bankAddress ? '\nBank Address: ' + this.info.bankAddress : ''}${this.info.bankCode ? '\nBank code (BSB): ' + this.info.bankCode : ''}${this.info.desc ? '\nDescription: ' + this.info.desc : ''}`
                    break
                case 'card':
                    details =
                        `Card: ${this.info.cardNumber}\nCard holder: ${this.info.name}`
                    break
                case 'ETH':
                    details = `ETH: ${this.info.wallet}`
                    break
                case 'USDT':
                    details = `USDT: ${this.info.wallet}`
                    break
                case 'USDC':
                    details = `USDC: ${this.info.wallet}`
                    break
                case 'MATIC':
                    details = `MATIC: ${this.info.wallet}`
                    break
                case 'BNB':
                    details = `BNB: ${this.info.wallet}`
                    break
                case 'zelle':
                    details = `Phone/Eamil:${this.info.contact}\nFull Name Zelle: ${this.info.name}`
                    break
            }

            let payload = {
                wallet: details,
                amount: amount,
                account_id: this.info.activeAccount.id,
                product: this.info.activeAccount.product,
                currency: this.info.activeAccount.currency
            }

            if(this.info.comment){
                payload.comment = this.info.comment
            }

            this.$store.dispatch(WITHDRAWAL_REQUEST, payload).then(() => {
                this.$emit('send')
            })
        },

    },
    computed: {
        ...mapGetters(['withdrawals', 'symbols','tokens'])
    }
}
</script>


<style scoped>

</style>
